import { type UserRole } from '../types/gateway';
import styles from './RoleSwitcher.module.css';

interface RoleSwitcherProps {
  currentRole: UserRole;
  onRoleChange: (role: UserRole) => void;
}

const ROLES: { key: UserRole; label: string; short: string; color: string }[] = [
  { key: 'designer', label: 'Designer', short: 'D', color: 'var(--blue)' },
  { key: 'field', label: 'Field', short: 'F', color: 'var(--green)' },
  { key: 'accounting', label: 'Accounting', short: 'A', color: 'var(--amber)' },
];

export function RoleSwitcher({ currentRole, onRoleChange }: RoleSwitcherProps) {
  return (
    <div className={styles.switcher}>
      {ROLES.map((role) => (
        <button
          key={role.key}
          className={`${styles.roleBtn} ${currentRole === role.key ? styles.active : ''}`}
          style={{
            borderColor: currentRole === role.key ? role.color : 'transparent',
            color: currentRole === role.key ? role.color : 'var(--muted)',
          }}
          onClick={() => onRoleChange(role.key)}
          title={role.label}
        >
          {role.short}
        </button>
      ))}
    </div>
  );
}
